'use strict';

var classes = {"tile-button":"tile-button__JBXJN","tile-button__icon":"tile-button__icon__wpSrf","tile-button__heading":"tile-button__heading__7LFWT","tile-button__description":"tile-button__description__-IGzq","tile-button--loading":"tile-button--loading__aR-TP"};

module.exports = classes;
//# sourceMappingURL=tile-button.module.scss.js.map
